import { AppService } from '../../../core/services/app.service';
import { PhotoOrder } from '../../../shared/models/cameralla-photo-order.model';
import { PhotoService } from "./photo.service";
import * as moment from 'moment';

export class VideoService extends PhotoService {
  videoUrl = AppService.getApiUrl() + '/api/videos';
  static SET_PHOTOS_FILTER = 'set-filter';
  static LAZY_LOADING_PHOTOS = 'lazy-loading-video';
  static SEARCH = 'photo-search';
  
  getVideosByOrder(filterList: any[], photoOrder: PhotoOrder, limit, skip, userId = null, isFavorite?, defaultFilter?) {
    const defaultQuery: any = [
      {
        status : 'done'
      }
    ]
    
    if (userId) {
      defaultQuery.push(
        {
          customerId : userId
        }
      )
    }
    
    if (isFavorite) {
      defaultQuery.push(
        {
          isFavorite : isFavorite
        }
      )
    } else {
      defaultQuery.push(
        {
          create_at: {
            between: [
              moment().subtract(1, "days").startOf('day').toString(),
              moment().endOf('day').toString(),
            ]
          }
        }
      )
    }
  
    if (defaultFilter && defaultFilter.tags) {
      if (defaultFilter.tags.length == 1) {
        defaultQuery.push({
          tags: {
            like: `%${defaultFilter.tags[0]}%`
          }
        });
      }
    
      if (defaultFilter.tags.length > 1) {
        defaultQuery.push({
          or: []
        });
      
        defaultFilter.tags.forEach((tag) => {
          defaultQuery[defaultQuery.length - 1].or.push({
              tags: {
                like: `%${tag}%`
              }
            }
          );
        });
      }
    }
    
    // TODO System/Mobile filter
    let queryObject: any = {
      where: {
        and: defaultQuery
      },
      include: 'customer',
      order: 'create_at desc',
      skip: +skip,
      limit: +limit,
    };

    queryObject = this.processParamsByOrder(queryObject, photoOrder, filterList);
    const filter = encodeURIComponent(JSON.stringify(queryObject));
    const url = `${this.videoUrl}/getAvailableVideos?filter=${filter}`;

    return this.http.get(url);
  }
}
